import {type PayloadAction, createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {getFlightList, getLatestCommodities} from 'services/common.service'
import {fetchDimentionalWeightFactor, getValidOdPair} from 'services/marketPlace.service'
import {sendEmail} from 'services/email.service'
import _ from 'lodash'

export interface common {
    isLoading: boolean
    errorMsg: any
    error: any
    result: any
    latestCommiditiesLoading: boolean
    latestCommiditiesError: any
    latestCommiditiesResults: any
    carrierRequestEmail: Record<string, any>
    ValidOdCarrier: Record<string, any>
    dimWeightFactorLoading: boolean
    dimWeightFactorResults: object
    dimWeightFactorError: any
    dimentions: any
    AZAccount: any
}

const initialState: common = {
    isLoading: false,
    errorMsg: null,
    error: [],
    result: null,
    latestCommiditiesLoading: false,
    latestCommiditiesError: null,
    latestCommiditiesResults: [],
    carrierRequestEmail: {},
    ValidOdCarrier: {},
    dimWeightFactorLoading: false,
    dimWeightFactorResults: {},
    dimWeightFactorError: null,
    dimentions: null,
    AZAccount: null
}

export const fetchResultList = createAsyncThunk(
    'common/fetchResultList',
    async (payload: any, {rejectWithValue, dispatch}) => {
        const checkAllErrorsExist = (data) =>
            data?.response?.every(
                (item) =>
                    _.get(item, 'ecidrqOut.svcError.entry.errTx', null) !== null &&
                    _.get(item, 'ecidrqOut.draout.entry', []).length === 0 &&
                    _.get(item, 'ecidrqOut.svcError.entry.errTx', '').includes(
                        'Routing is not available . Please contact concern team.'
                    ) !== true &&
                    _.get(item, 'ecidrqOut.svcError.entry.errTx', '').includes(
                        'No Matching Records found.'
                    ) !== true
            )

        try {
            const {data} = await getFlightList(payload)
            const arr: any = []
            const filteredErr = data?.response?.filter(
                (err) =>
                    err?.ecidrqOut && err?.ecidrqOut?.svcError?.entry?.errTx && !err?.ecidrqOut?.draout?.entry?.length
            )
            dispatch(setError(filteredErr))
            if (!data.successFlag) {
                throw Error(data.errorList)
            } else if (checkAllErrorsExist(data)) {
                throw Error('System error')
            }
            // eslint-disable-next-line
            data?.response?.map((d, i) =>
                d?.ecidrqOut?.draout?.entry?.map((a, b) =>
                    a?.product?.map((p, q) =>
                        arr.push({
                            carrier: d?.ecidrqOut?.carrierName,
                            shcCode: d?.ecidrqOut?.shcCode,
                            commodityAA: d?.ecidrqOut?.commodityAA,
                            relatedAccountID: _.get(d, 'ecidrqOut.relatedAccountId', ''),
                            accountId: _.get(d, 'ecidrqOut.accountId', ''),
                            cCurreny: d?.ecidrqOut?.draout?.option?.currency,
                            volumeUnit: d?.ecidrqOut?.draout?.vuni,
                            WeightUnit: d?.ecidrqOut?.draout?.wuni,
                            Duration: a?.duration,
                            RequestRefId: _.get(a, 'requestRefId', ''),
                            productDetails: {...p},
                            // eslint-disable-next-line no-unsafe-optional-chaining
                            seg: [...a?.seg]
                        })
                    )
                )
            )
            return arr
        } catch (err: any) {
            const error: any = err // cast the error for access
            return rejectWithValue(error.message)
        }
    }
)

export const fetchLatestCommodity = createAsyncThunk(
    'common/fetchLatestCommodity',
    async (payload: any, {rejectWithValue}) => {
        try {
            if (payload?.code?.length >= 1) {
                const {data} = await getLatestCommodities(payload)
                if (!data.successFlag) {
                    throw Error(data.errorList)
                }
                return {data, ...payload}
            }
        } catch (err: any) {
            const error: any = err // cast the error for access
            return rejectWithValue(error.message)
        }
    }
)
export const triggerCarrierRequestEmail = createAsyncThunk(
    'triggerCarrierRequestEmail',
    async (payload: any, {dispatch, rejectWithValue}) => {
        try {
            const {data} = await sendEmail(payload)
            if (data?.successFlag) {
                return 'Email sent sucessfully'
            } else {
                return rejectWithValue({
                    error: {text: 'Data unavailable.', code: '500'}
                })
            }
        } catch (err: any) {
            return rejectWithValue({
                error: {
                    text: 'Data unavailable.',
                    code: '500'
                }
            })
        }
    }
)
export const fetchValidOdCarrier = createAsyncThunk(
    'fetchValidOdCarrier',
    async (payload: any, {dispatch, rejectWithValue}) => {
        try {
            const {data} = await getValidOdPair(payload)
            if (data?.successFlag) {
                return data?.response
            } else {
                return rejectWithValue({
                    error: {text: 'Data unavailable.', code: '500'}
                })
            }
        } catch (err: any) {
            return rejectWithValue({
                error: {
                    text: 'Data unavailable.',
                    code: '500'
                }
            })
        }
    }
)

const throwError = (data) => {
    if (!data.successFlag || typeof data === 'string') {
        throw Error(String(data.errorList).match(/text=(.*?)(?=\])/)?.[1] ?? 'Something went wrong')
    }
}

export const fetchDimentionalWeight = createAsyncThunk(
    'fetchDimentionalWeight',
    async (payload: any, {rejectWithValue}) => {
        try {
            const {data} = await fetchDimentionalWeightFactor(payload)
            throwError(data)
            return {
                response: data.response,
                payload
            }
        } catch (err: any) {
            return rejectWithValue({
                error: err.message,
                payload
            })
        }
    }
)

export const resultSlice = createSlice({
    name: 'resultList',
    initialState,
    reducers: {
        resetState: () => initialState,
        resetCarrierRequestEmail: (state) => {
            state.carrierRequestEmail = {}
        },
        setDimentions: (state, action: PayloadAction<object>) => {
            state.dimentions = action.payload
        },
        setError: (state, action) => {
            state.error = action?.payload
        },
        setAzaccount: (state, action) => {
            state.AZAccount = action?.payload
        }
    },
    extraReducers: function (builder) {
        builder.addCase(fetchResultList.pending, (state, action) => {
            state.isLoading = true
        })
        builder.addCase(fetchResultList.fulfilled, (state, action) => {
            state.isLoading = false
            state.result = action.payload
        })
        builder.addCase(fetchResultList.rejected, (state, action: any) => {
            state.isLoading = false
            state.result = null
            state.errorMsg = action.payload
        })
        builder.addCase(fetchLatestCommodity.pending, (state, action) => {
            state.latestCommiditiesLoading = true
        })
        builder.addCase(fetchLatestCommodity.fulfilled, (state, action) => {
            const appendData =
                action.payload?.data?.length <= 0
                    ? action?.payload
                    : {...action.payload?.data, lazyLoad: action?.payload?.lazyLoad}
            state.latestCommiditiesLoading = false
            state.latestCommiditiesResults = appendData
            state.latestCommiditiesError = null
        })
        builder.addCase(fetchLatestCommodity.rejected, (state, action: any) => {
            state.latestCommiditiesLoading = false
            state.latestCommiditiesResults = null
            state.latestCommiditiesError = action.payload
        })
        builder.addCase(triggerCarrierRequestEmail.fulfilled, (state, action: any) => {
            state.carrierRequestEmail.isLoading = false
            state.carrierRequestEmail.error = null
            state.carrierRequestEmail.data = action?.payload || {}
        })
        builder.addCase(triggerCarrierRequestEmail.rejected, (state, action: any) => {
            state.carrierRequestEmail.isLoading = false
            state.carrierRequestEmail.error = action.payload.error
            state.carrierRequestEmail.data = action.payload || {}
        })
        builder.addCase(triggerCarrierRequestEmail.pending, (state) => {
            state.carrierRequestEmail.isLoading = true
            state.carrierRequestEmail.error = null
            state.carrierRequestEmail.data = {}
        })
        builder.addCase(fetchValidOdCarrier.fulfilled, (state, action: any) => {
            state.ValidOdCarrier.isLoading = false
            state.ValidOdCarrier.error = null
            state.ValidOdCarrier.data.response = action?.payload || {}
        })
        builder.addCase(fetchValidOdCarrier.rejected, (state, action: any) => {
            state.ValidOdCarrier.isLoading = false
            state.ValidOdCarrier.error = action.payload.error
            state.ValidOdCarrier.data = {}
        })
        builder.addCase(fetchValidOdCarrier.pending, (state) => {
            state.ValidOdCarrier.isLoading = true
            state.ValidOdCarrier.error = null
            state.ValidOdCarrier.data = {}
        })
        builder.addCase(fetchDimentionalWeight.pending, (state, action) => {
            state.dimWeightFactorLoading = true
        })
        builder.addCase(fetchDimentionalWeight.fulfilled, (state, action) => {
            state.dimWeightFactorLoading = false
            state.dimWeightFactorResults = action.payload.response
            state.dimWeightFactorError = null
        })
        builder.addCase(fetchDimentionalWeight.rejected, (state, action: any) => {
            state.dimWeightFactorLoading = false
            state.dimWeightFactorResults = []
            state.dimWeightFactorError = action.payload.error
        })
    }
})
export const {resetState, resetCarrierRequestEmail, setDimentions, setError, setAzaccount} = resultSlice.actions
export const {reducer: resultReducer} = resultSlice
